
// Custom Hook for double materiality helpers
function useDoubleMatHelper() {

	const isSurveyCompleted = (stats) => {
		const notSharedCount = stats?.assessment?.submissionStatusCount?.NOT_SHARED ?? 0;
		const inProgressCount = (stats?.assessment?.submissionStatusCount?.IN_PROGRESS ?? 0)
			+ (stats?.assessment?.submissionStatusCount?.CORRECTION_PENDING ?? 0)
			+ (stats?.assessment?.submissionStatusCount?.PENDING_APPROVAL ?? 0);

		const isCompleted = stats?.assessment?.sharedOn
			&& inProgressCount === 0
			&& stats?.assessment?.submissionStatusCount?.DRAFT === 0
			&& stats?.assessment?.submissionStatusCount?.COMPLETED > 0;
		const lastSubmissionDate = new Date(stats?.assessment?.lastSubmissionDate);
		const isExpired = isCompleted === true ? false : lastSubmissionDate < new Date();
		return stats?.assessment?.sharedOn
			&& inProgressCount === 0
			&& !isExpired
			&& stats?.assessment?.submissionStatusCount?.DRAFT === 0
			&& stats?.assessment?.submissionStatusCount?.COMPLETED > 0
			&& notSharedCount === 0;
	};

	return {
		isSurveyCompleted,
	};
};


export default useDoubleMatHelper;